const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';



class ApiService {

  constructor() {

    this.token = localStorage.getItem('authToken');

  }



  setToken(token) {

    this.token = token;

    if (token) {

      localStorage.setItem('authToken', token);

    } else {

      localStorage.removeItem('authToken');

    }

  }



  getToken() {

    return this.token || localStorage.getItem('authToken');

  }



  async request(endpoint, options = {}) {

    const url = `${API_URL}${endpoint}`;

    const headers = {

      'Content-Type': 'application/json',

      ...options.headers,

    };



    const token = this.getToken();

    if (token) {

      headers['Authorization'] = `Bearer ${token}`;

    }



    const config = {

      ...options,

      headers,

    };



    try {

      const response = await fetch(url, config);

      const data = await response.json();



      if (!response.ok) {

        throw new Error(data.error || data.message || 'Request failed');

      }



      return data;

    } catch (error) {

      console.error('API Error:', error);

      throw error;

    }

  }



  async login(email, password) {

    const data = await this.request('/api/auth/login', {

      method: 'POST',

      body: JSON.stringify({ email, password }),

    });



    if (data.ok && data.token) {

      this.setToken(data.token);

      // Store user data with snake_case field names

      const user = {

        id: data.user.id,

        email: data.user.email,

        first_name: data.user.firstName,

        last_name: data.user.lastName,

        phone: data.user.phone,

        company: data.user.company,

        job_title: data.user.jobTitle,

        avatar_url: data.user.avatarUrl,

      };

      localStorage.setItem('currentUser', JSON.stringify(user));

    }



    return data;

  }



  async register(email, password, firstName, lastName) {

    const data = await this.request('/api/auth/signup', {

      method: 'POST',

      body: JSON.stringify({ 

        email, 

        password, 

        confirmPassword: password,

        firstName, 

        lastName 

      }),

    });



    if (data.ok && data.user) {

      // For signup, we need to login to get a token

      const loginData = await this.login(email, password);

      return loginData;

    }



    return data;

  }



  async logout() {

    this.setToken(null);

    localStorage.removeItem('currentUser');

    return { ok: true };

  }



  async getCurrentUser() {

    try {

      // Check if we have a stored user in localStorage

      const storedUser = localStorage.getItem('currentUser');

      if (storedUser && this.getToken()) {

        return JSON.parse(storedUser);

      }

      return null;

    } catch (error) {

      this.setToken(null);

      localStorage.removeItem('currentUser');

      return null;

    }

  }



  async updateProfile(updates) {

    const data = await this.request('/api/auth/profile', {

      method: 'PUT',

      body: JSON.stringify(updates),

    });



    if (data.ok && data.user) {

      // Update stored user data with snake_case field names

      const user = {

        id: data.user.id,

        email: data.user.email,

        first_name: data.user.firstName,

        last_name: data.user.lastName,

        phone: data.user.phone,

        company: data.user.company,

        job_title: data.user.jobTitle,

        avatar_url: data.user.avatarUrl,

      };

      localStorage.setItem('currentUser', JSON.stringify(user));

    }



    return data;

  }



  async getMyCard() {

    const response = await this.request('/api/card/my-card');

    if (response.ok && response.data) {

      // Backend returns camelCase, convert to snake_case for consistency

      const card = response.data;

      return {

        ok: true,

        card: {

          id: card.id,

          full_name: card.fullName,

          business_name: card.businessName,

          job_title: card.jobTitle,

          email: card.email,

          phone_number: card.phoneNumber,

          cellphone: card.cellphone || '',

          whatsapp: card.whatsapp || '',

          wechat: card.wechat || '',

          website: card.website,

          address: card.address,

          business_logo_url: card.businessLogo,

          template_style: card.templateStyle,

          custom_colors: card.customColors,

          social_links: card.socialLinks,

          public_url_slug: card.public_url_slug || card.publicUrl?.split('/').pop() || card.id,

          slug_last_changed_at: card.slugLastChangedAt || null,

          is_active: card.isActive,

          created_at: card.createdAt,

          updated_at: card.updatedAt,

        }

      };

    }

    return response;

  }



  async checkSlug(slug) {

    return await this.request(`/api/card/check-slug/${encodeURIComponent(slug)}`);

  }



  async updateCard(cardData) {

    return await this.request('/api/card/my-card', {

      method: 'POST',

      body: JSON.stringify(cardData),

    });

  }



  async getPublicCard(cardId) {
    // Try slug-based lookup first (custom usernames like "ramisj12")
    const slugResult = await this.request(`/by-slug/${cardId}`);
    if (slugResult.ok) return slugResult;
    // Fall back to shared card ID lookup (QR code links)
    return await this.request(`/card/${cardId}`);
  }



  async uploadLogo(file) {

    const formData = new FormData();

    formData.append('logo', file);



    const token = this.getToken();

    const headers = {};

    if (token) {

      headers['Authorization'] = `Bearer ${token}`;

    }



    const response = await fetch(`${API_URL}/api/card/upload-logo`, {

      method: 'POST',

      headers,

      body: formData,

    });



    const data = await response.json();

    if (!response.ok) {

      throw new Error(data.error || 'Upload failed');

    }



    return data;

  }



  // Contact methods
  async getContacts() {
    return await this.request('/api/contacts');
  }

  async getContact(contactId) {
    return await this.request(`/api/contacts/${contactId}`);
  }

  async createContact(contactData) {
    return await this.request('/api/contacts', {
      method: 'POST',
      body: JSON.stringify(contactData),
    });
  }

  async updateContact(contactId, contactData) {
    return await this.request(`/api/contacts/${contactId}`, {
      method: 'PUT',
      body: JSON.stringify(contactData),
    });
  }

  async deleteContact(contactId) {
    return await this.request(`/api/contacts/${contactId}`, {
      method: 'DELETE',
    });
  }

  async signInWithGoogle(googleUser) {

    const { email, name, picture } = googleUser;

    

    const data = await this.request('/api/auth/google', {

      method: 'POST',

      body: JSON.stringify({ email, name, picture }),

    });



    if (data.ok && data.token) {

      this.setToken(data.token);

      // Store user data with snake_case field names

      const user = {

        id: data.user.id,

        email: data.user.email,

        first_name: data.user.firstName,

        last_name: data.user.lastName,

        phone: data.user.phone,

        company: data.user.company,

        job_title: data.user.jobTitle,

        avatar_url: data.user.avatarUrl,

      };

      localStorage.setItem('currentUser', JSON.stringify(user));

    }



    return data;

  }

}



const apiService = new ApiService();

export default apiService;

